import { useFeedback } from "@opendash/core";
import { useTranslation } from "@opendash/i18n";
import { useState } from "react";
import { Message } from "../../../../js/parsegenerated";

export const useTodoMessage = (message: Message) => {
  const t = useTranslation();
  const { handleLoadingFeedback } = useFeedback();
  const [loading, setLoading] = useState(false);

  async function toggleTodo(checked: boolean) {
    setLoading(true);
    try {
      await handleLoadingFeedback(
        async () => {
          const data = message.data || {};
          data.todoCompleted = checked;

          return await message.save({ data });
        },
        t("maintenance:ticket.todos.change.loading"),
        t("maintenance:ticket.todos.change.success"),
        t("maintenance:ticket.todos.change.error")
      );
    } catch (e) {
      console.error(e);
    }
    setLoading(false);
  }

  async function deleteTodo() {
    setLoading(true);
    try {
      await handleLoadingFeedback(
        async () => {
          return await message.destroy();
        },
        t("maintenance:ticket.todos.change.loading"),
        t("maintenance:ticket.todos.change.success"),
        t("maintenance:ticket.todos.change.error")
      );
    } catch (e) {
      console.error(e);
    }
    setLoading(false);
  }

  return { toggleTodo, deleteTodo, loading };
};
